import { TAddOn } from "@/components/Checkout/types.checkout";

/**
 * Returns the max count of the add on. A `null` `max_count` means there is no
 * limit, so we return `Infinity` to keep arithmetic/comparisons working.
 */
export function getAddOnMaxCount(addOn: Pick<TAddOn, "max_count">): number {
  if (!addOn) return 0;
  return addOn.max_count ?? Infinity;
}
